// Source/Selling-Section/Component.ts
import { Pagination, Navigation, Swiper } from "Swiper";
class SellingSection extends HTMLElement {
  swiper;
  connectedCallback() {
    this.swiper = new Swiper(".Selling-Swiper", {
      modules: [Pagination, Navigation],
      direction: "horizontal",
      navigation: {
        prevEl: ".Selling-Control[ name = previous ]",
        nextEl: ".Selling-Control[ name = next ]"
      },
      slidesPerView: 1,
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        1000: {
          slidesPerView: 3
        }
      }
    });
  }
  disconnectedCallback() {
    this.swiper?.destroy();
  }
}

// Source/Selling-Section/mod.ts
customElements.define("selling-section", SellingSection);
